import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionInvoiceService {

    constructor(private http: HttpClient) {}

    createSubscriptionInvoice(data: any) {
        return this.http
          .post<any>(
            `${environment.url_api}/dashboard/subscription-invoices`,
            data,
          );
    }

    updateSubscriptionInvoice(invoiceId: number, data: any) {
        return this.http
          .put<any>(
            `${environment.url_api}/dashboard/subscription-invoices/${invoiceId}`,
            data,
          );
    }

    paidInvoice(invoiceId: number, paidStatus: boolean = true) {
        return this.http
          .put<any>(
            `${environment.url_api}/dashboard/subscription-invoices/${invoiceId}/paid`,
            {
              paid: paidStatus,
            },
          );
    }

    deleteSubscriptionInvoice(invoiceId: number) {
        return this.http
          .delete<any>(
            `${environment.url_api}/dashboard/subscription-invoices/${invoiceId}`,
          );
    }


}
